import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import IArborStaffUserTypeMapping from "../../../../models/misconfig/arbor/userTypes/ArborStaffUserTypeMapping";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { IArborUserTypeSubEditProps } from "./arbor-usertype-edit";

const ArborStaffUserTypeEdit = forwardRef((props: IArborUserTypeSubEditProps, ref) => {
    const [arborConfig, setArborConfig] = useState<IArborStaffUserTypeMapping | null>(null);
    const hasInitializedRef = useRef<boolean>(false);

    useEffect(() => {        
        if (props.configJson && !hasInitializedRef.current) {
            const configObj: IArborStaffUserTypeMapping = JSON.parse(props.configJson);
            setArborConfig(configObj);
            hasInitializedRef.current = true;
        }
    }, [props.configJson]);

    const updateIncludeStaffBusinessRoles = (value: boolean) => {
        setArborConfig(prev => ({...prev!, IncludeStaffBusinessRoles: value}));
        props.handleChange('IncludeStaffBusinessRoles', value);
    }

    useImperativeHandle(ref, () => ({
        validate: function() : boolean {
           return true;
        }}));

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={props.firstCol} className="pt-2">Include business roles?</Col>
                <Col md={props.secondCol}>
                    <select className="form-select mt-1 ms-0 w-100" value={arborConfig?.IncludeStaffBusinessRoles ? 'true' : 'false'}
                        onChange={e => updateIncludeStaffBusinessRoles(e.target.value === 'true')}>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </Col>
            </Row>
        </React.Fragment>
    );
});

export default ArborStaffUserTypeEdit;